import "./administrative-law.dff6a4f3.js";
import "./advocatapp.ba50b607.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire48bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire48bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
//src\js\slick-carousel.js



var $aaQnt = parcelRequire("aaQnt");
parcelRequire("bm1CF");
(0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(document).ready(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.cases-slider-wrapper').slick({
        slidesToShow: 1.95,
        slidesToScroll: 3,
        arrows: true,
        prevArrow: (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.cases-prev-slide'),
        nextArrow: (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.cases-next-slide'),
        centerPadding: '10px',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1.95,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // Добавляем пассивные обработчики событий
    document.addEventListener('touchstart', onTouchStart, {
        passive: true
    });
    document.addEventListener('touchmove', onTouchMove, {
        passive: true
    });
    function onTouchStart(event) {
    // Обработчик touchstart
    }
    function onTouchMove(event) {
    // Обработчик touchmove
    }
});


//# sourceMappingURL=cases.3998d7fb.js.map
